import { useState } from 'react';
import { useApi } from '../lib/api';
import { useHealth } from '../lib/hooks';
import { Field, SourceChip } from '../ui';
import { InjectionSettings } from './Internal';

export default function Settings() {
  const { base, token, setConn } = useApi();
  const { data: health } = useHealth();
  const [b, setB] = useState(base);
  const [k, setK] = useState(token);
  const [saved, setSaved] = useState(false);

  function save() {
    setConn({ base: b.replace(/\/$/, ''), token: k });
    setSaved(true);
  }
  function forget() {
    setConn({ token: '' });
    // Re-mount App at the gate.
    window.location.reload();
  }

  return (
    <>
    <div className="grid gap-3.5" style={{ gridTemplateColumns: '1fr 1fr' }}>
      <div className="blk">
        <div className="blk-head">
          <h3 className="text-[13px] font-semibold">Connection</h3>
        </div>
        <div className="blk-body space-y-3">
          <Field label="API base">
            <input
              className="input mono"
              value={b}
              onChange={(e) => {
                setB(e.target.value);
                setSaved(false);
              }}
              placeholder="leave blank for same origin"
            />
          </Field>
          <Field label="API key">
            <input
              className="input mono"
              type="password"
              value={k}
              onChange={(e) => {
                setK(e.target.value);
                setSaved(false);
              }}
            />
          </Field>
          <div className="flex items-center gap-2 pt-1">
            <button className="btn btn-primary" onClick={save}>
              Save
            </button>
            <button className="btn btn-danger" onClick={forget}>
              Forget key &amp; lock
            </button>
            {saved && <span className="text-[12px] text-ok">Saved.</span>}
          </div>
        </div>
      </div>

      <div className="blk">
        <div className="blk-head">
          <h3 className="text-[13px] font-semibold">Sources</h3>
          <span className="text-[11.5px] text-faint">from /health · enabled via server .env</span>
        </div>
        <div className="blk-body space-y-2.5">
          {(health?.sources ?? []).map((s) => (
            <div key={s} className="flex items-center gap-2">
              <SourceChip source={s} />
              <span className="ml-auto text-[12px] text-ok">enabled</span>
            </div>
          ))}
          {health && (health.sources?.length ?? 0) === 0 && (
            <div className="text-[12px] text-muted">No sources configured.</div>
          )}
          <div className="pt-1 text-[11.5px] text-faint">
            Per-source timeout is 10s — a slow source degrades its section but never blocks the rest of the response.
          </div>
        </div>
      </div>
    </div>

    {/* Injection is a server-side behaviour, so it lives with the server settings —
        not with the connection details, which are only this browser's. */}
    <div className="mt-3.5">
      <InjectionSettings />
    </div>
    </>
  );
}
